module.exports = __webpack_public_path__ + "img/safe_04.fc71e36b.png";